import React from 'react'
import classnames from 'classnames';
import PropTypes from 'prop-types'
import lang from '../../language/services/Lang';
import './Badges.scss'

const ProductBadge = props => {

    const { productCode, height, className } = props    

    const badgeStyle = {
        height: height || 40,
        width: height || 40
    }

    const getProductLabel = (prodCode) => {
        if (prodCode === 'PRESALE') {
            return lang.getCurrentValue('ReturnInfo.ProductAbbr.PRESALE')
        } else if (prodCode === 'OTE' || prodCode === 'PEL') {
            return lang.getCurrentValue('ReturnInfo.ProductAbbr.OTE')
        } else if (prodCode === 'VDO') {
            return lang.getCurrentValue('ReturnInfo.ProductAbbr.RTE')
        } else if (prodCode === 'VIR') {
            return lang.getCurrentValue('ReturnInfo.ProductAbbr.VIR')
        } else if (prodCode === 'RTE') {
            return lang.getCurrentValue('ReturnInfo.ProductAbbr.RTETPSC')
        } else if (prodCode === 'RTEDR') {
            return lang.getCurrentValue('ReturnInfo.ProductAbbr.RTETPSC')
        } else {
            return productCode.toUpperCase()
        }
    }

    return (
        <div className={classnames('product', productCode.toLowerCase(), className)} style={badgeStyle}>
            <div className='badge'>
                <div className={classnames('name', { 'presale': props.title === 'PRESALE' })}>
                    {getProductLabel(productCode)}
                </div>
            </div>
        </div>)
}

ProductBadge.propTypes = {
    productCode: PropTypes.string.isRequired,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    className: PropTypes.string
}

export default ProductBadge